import React from 'react';
import { useTable } from 'react-table';
import { isNullOrUndefined } from 'utils/Global';
import CheckBox from 'components/customComponents/Experiment/ImagingSchedule/CheckBox';

export function Table({
  columns,
  data,
  cellProps = (row) => ({}),
  classNames = '',
}: any) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  return (
    <table  
      id='optimizationcomponents-table'
      className={'optimization-table ' + classNames}
      {...getTableProps()}
      style={{ overflow: 'auto', width: '100%' }}
    >
      <thead id='optimizationcomponents-table-theader'>
        {headerGroups.map((headerGroup, index) => (
          <tr
            id={`optimizationcomponents-table-headerrow-${index}`}
            key={`headerGroup${index}`}
            style={{ display: 'flex' }}
            {...headerGroup.getHeaderGroupProps()}
          >
            {headerGroup.headers.map((column, i) => (
              <th
                id={`optimizationcomponents-table-headercell-${index}-${i}`}
                key={`groupCol${i}`}
                {...column.getHeaderProps(cellProps(column))}
                style={{ flex: column.width }}
              >
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody id="optimizationcomponents-table-tbody" {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr id={`optimizationcomponents-table-row-${i}`}
              key={`row${i}`} style={{ display: 'flex' }} {...row.getRowProps()}>
              {row.cells.map((cell, index) => {
                return (
                  <td id={`optimizationcomponents-table-cell-${i}-${index}`}
                    {...cell.getCellProps(cellProps(row))}
                    key={`cell_${index}`}
                    style={{ flex: cell.column.width }}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export enum OptTextVariants {
  normal = 1,
  heading = 2,
  label = 3,
  warning = 4,
  error = 5,
}

type OptimizationTextProps = {
  text: string;
  variant?: OptTextVariants;
  className?: any;
  style?: any;
};
export const OptimizationText = ({
  text,
  variant,
  className,
  style,
}: OptimizationTextProps) => {
  let textStyle = {
    fontWeight: 400,
    fontSize: '14px',
    margin: '0rem',
    lineHeight: '16.1px',
  };
  switch (variant) {
    case OptTextVariants.heading:
      textStyle.fontWeight = 700;
      textStyle['paddingBottom'] = '1rem';
      break;
    case OptTextVariants.label:
      textStyle.fontSize = '13px';
      break;
    case OptTextVariants.warning:
      textStyle.fontWeight = 700;
      textStyle['color'] = '#F7A246';
      textStyle['paddingBottom'] = '1rem';
      break;
    case OptTextVariants.error:
      textStyle['color'] = '#DB0000';
      textStyle['paddingBottom'] = '1rem';
      break;
  }

  if (!isNullOrUndefined(style)) {
    textStyle = { ...textStyle, ...style };
  }
  return (
    <p id={`optimizationcomponents-text-${text}`} className={className} style={textStyle}>
      {text}
    </p>
  );
};

type CheckBoxRowProps = {
  isChecked: boolean;
  onChange: (e) => void;
  label: string;
};

export const CheckBoxRow = ({ isChecked, onChange, label }: CheckBoxRowProps) => {
  return (
    <div
      id={`optimizationcomponents-checkboxrow`}
      style={{
        marginRight: '1rem',
        marginBottom: '1rem',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      <CheckBox isChecked={isChecked} onChange={() => onChange(!isChecked)} />
      <OptimizationText text={label} variant={OptTextVariants.label} />
    </div>
  );
};
